<template>
    <div>

        <config-main-title>
            Portal Abas
        </config-main-title>

        <div v-if="!em_edicao">

            <div class="row mb-3">
                <div class="col col-12 col-md-6 d-flex flex-column">
                    <az-input icon="fas fa-search" v-model="search" />
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <div class="btn-group mb-1" role="group" aria-label="Basic example">
                        <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'A'">
                            Ativos
                        </button>
                        <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'T'">
                            Todos
                        </button>
                    </div>
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <button type="button" class="btn btn-outline-success" @click="incluir ()">
                        Incluir Aba
                    </button>
                </div>
            </div>

        </div>

        <div v-if="( !lista || !lista.length )">
            <az-empty-state 
                :msg="'Nenhuma Aba identificada.'" 
                icon="fa-solid fa-folder"
                :action="'Incluir Aba'" 
                :method="incluir" />
		</div>

        <div v-if="!em_edicao && lista && lista.length">

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item d-flex justify-content-between" v-for="(dado, id) in lista" :key="id">
                    <span>
                        <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3">
                            {{ dado.search }}
                        </a>

                        <span class="badge badge-secondary ml-2">#{{  dado.id_apoiado_portal_aba }}</span>
                    </span>
                    <span>
                        <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                            <input type="checkbox" class="custom-control-input" 
                                :id="'ativo-' + id" 
                                v-model="dado.fl_ativo" 
                                @change="toggle(dado)">
                            <label class="custom-control-label" :for="'ativo-' + id"></label>
                        </div>
                        <span v-else>
                            <span class="badge badge-secondary" title="Ordem">
                                <i class="fa-solid fa-sort"></i>
                                {{ dado.in_ordem }}
                            </span>

                            <button class="btn btn-sm btn-outline-primary ml-2" 
                                @click="abrir_anexar_arquivo(dado)" 
                                data-toggle="tooltip" 
                                :title="'Anexar/Visualizar Arquivos'">
                                <i class="fa-solid fa-paperclip"></i>
                                <span v-if="dado.arquivos && dado.arquivos.length" class="badge badge-primary ml-1">
                                    {{ dado.arquivos.length }}
                                </span>
                            </button>
                        </span>
                    </span>
                </li>
            </div>
        </div>

        <!-- Formulário de edição -->
        <div class="modal fade" id="edicaoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            {{ ( item && item.id_apoiado_portal_aba ) ? '' : 'Nova' }}
                            Aba
                            <span v-if="item && item.id_apoiado_portal_aba">
                                #{{ item.id_apoiado_portal_aba }}
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="item">
                        <div class="form-row">
                            <div class="col col-12 col-md-9">
                                <az-input
                                    label="Título"
                                    required
                                    :validate="validate"
                                    v-model="item.st_titulo" />
                            </div>

                            <div class="col col-12 col-md-3">
                                <az-input
                                    label="Ordem"
                                    type="number"
                                    required
                                    :validate="validate"
                                    v-model="item.in_ordem" />
                            </div>
                        </div>

                        <div class="form-row my-2">
                            <div class="col col-12 col-md-4">
                                <az-input
                                    sizing="sm"
                                    label="Paciente"
                                    type="checkbox-group"
                                    :validate="validate"
                                    v-model="item.fl_paciente" />
                            </div>

                            <div class="col col-12 col-md-4">
                                <az-input
                                    sizing="sm"
                                    label="Apoiado"
                                    type="checkbox-group"
                                    :validate="validate"
                                    v-model="item.fl_apoiado" />
                            </div>

                            <div class="col col-12 col-md-4">
                                <az-input
                                    sizing="sm"
                                    label="Solicitante"
                                    type="checkbox-group"
                                    :validate="validate"
                                    v-model="item.fl_solicitante" />
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12">
                                <az-input
                                    label="Tipo de Conteúdo"
                                    type="select"
                                    :optionsList="[
                                        { id: 'T', search: 'Texto' }, 
                                        { id: 'H', search: 'HTML' }, 
                                    ]"
                                    optionsData="id"
                                    :validate="validate"
                                    v-model="item.st_tipo_conteudo" />
                            </div>
                        </div>

                        <div class="form-row mb-2">
                            <div class="col col-12">
                                <az-input
                                    label="Conteúdo"
                                    type="textarea"
                                    rows="5"
                                    :validate="validate"
                                    v-model="item.st_conteudo" />
                            </div>
                        </div>

                        <div class="form-row" v-if="item.fl_apoiado">
                            <div class="col col-12">
                                <az-input
                                    sizing="sm"
                                    label="Exibir Anexos do Apoiado"
                                    type="checkbox-group"
                                    :validate="validate"
                                    v-model="item.fl_anexos" />
                            </div>
                        </div>

                        <div class="form-row mb-2">
                            <div class="col col-12">
                                <az-input
                                    label="Observações"
                                    type="textarea"
                                    rows="3"
                                    :validate="validate"
                                    v-model="item.st_observacoes" />
                            </div>
                        </div>

                        <!-- Filtros -->
                         <template v-if="item.fl_apoiado">
                            <filtro-model title="Filtros do Apoiado" class="my-3" v-model="item.filtros" :validate="validate" :opcoes="lista_opcoes_filtro" />
                        </template>
                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button model="apoiadoPortalAba" :id="item.id_apoiado_portal_aba" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar ()">{{ item.id_apoiado_portal_aba ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <edicao-acessos ref="acessos" @refresh="load()" />

        <!-- Envio de Arquivo -->
        <template v-if="acao_anexar">
            <az-file-upload
                ref="upload"
                @refresh="carregar_arquivos()"
                :multiple="true"
                :arquivos="aba.arquivos"
                :parms="{ model_type: 'apoiadoPortalAba', model_id: aba.id_apoiado_portal_aba }" />
        </template>

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import EdicaoAcessos from '../shared/EdicaoAcessos.vue';
import AzFileUpload from '../../util/AzFileUpload.vue';
import FiltroModel from '../shared/FiltroModel.vue';

export default {
    data () { 
        return { 
            dados: null, 
            em_edicao: false, 
            item: null, 
            validate: false,
            search: "", 
            viewMode: "A",
            title: "", 
            short_title: "", 
            service: "",
            outros_acessos: [],
            is_reembolso: false, 
            is_infusao: false, 
            aba: null, 
            acao_anexar: false,
        }
    },

    props: ['teste'],

    components: { 
        ConfigMainTitle,
        AzInput,
        AzEmptyState,
        AzSubmit,
        AzAuditLogButton,
        EdicaoAcessos, 
        AzFileUpload, 
        FiltroModel, 
    },

    computed: { 
        lista: function () { 
            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.dados && this.dados.length ? 
                this.dados.filter (item => { 
                    return ( this.viewMode == 'T' || item.fl_ativo ) && 
                        ( !this.search || reg.test(JSON.stringify(item)) );
                }) : null;
        },

        tem_acesso: function () { 
            return 'tarefa_prioridade' == 'atendimento'
                || 'tarefa_prioridade' == 'receita';
        },

        lista_opcoes_filtro: function () { 
            let opcoes = [                        
                {id:'App\\azure\\apoiado', search:'Apoiado', service: 'apoiados.index'}, 
                // {id:'tag-apoiado', search:'Classificação do Apoiado', service: 'apoiados.index', parms: { ativos: true }, tag: true}, 
            ];

            if ( this.item && this.item.fl_anexos ) { 
                opcoes.push({id:'App\\azure\\tipoArquivo', search: 'Tipo de Arquivo', service: 'tipo_arquivos.index', parms: { model: 'apoiado' } }); 
            }

            return opcoes; 
        },

    },

    methods: { 
        abrir_anexar_arquivo(aba) { 
            this.aba = aba;
            this.acao_anexar = true;

            if ( this.aba.arquivos && this.aba.arquivos.length && !this.aba.arquivos.find(arq => arq.arquivo) ) { 
                this.carregar_arquivos(true);
                return;
            }

            this.$nextTick(() => { 
                this.$refs.upload.abrir();
            });
        },

        carregar_arquivos (abrir = false) { 

            this.$store.commit('loading', true);

            this.$util.loadItem(this, { 
                service: 'arquivos',
                func: 'links',
                parms: { 
                    id: this.aba.id_apoiado_portal_aba, 
                    type: 'apoiadoPortalAba',
                }
            })
            .then(res => { 
                this.aba.arquivos = res;

                if ( abrir ) { 
                    this.$nextTick(() => { 
                        this.$refs.upload.abrir();
                    });
                }
            })
            .finally(() => { 
                this.$store.commit('loading', false);
            });

        },

        //

        acessos(item, outro) { 
          this.$refs.acessos.abrir(
              'App\\azure\\tarefaPrioridade', 
              item.id_prioridade, 
              _.get(outro, 'search'), 
              _.get(outro, 'id')
            );
        },

        incluir () { 
            this.validate = false;

            let item = {
                id_apoiado_portal_aba: null, 
                st_titulo: "", 
                fl_ativo: true, 
                st_observacoes: "", 
                fl_apoiado: false,
                fl_paciente: false,
                fl_solicitante: false,
                fl_anexos: false, 
                in_ordem: 0,
                filtros: [], 
                st_tipo_conteudo: 'T',
                st_conteudo: "",
            };

            this.editar (item);
        },
        load () { 
            this.$util.load(this, { 
                service:'apoiado_portal_abas',
                func: 'index',
                parms: { 
                    cadastro: true, 
                }
            });
        },
        editar (item) { 
            this.validate = false;

            this.item = _.cloneDeep (item);

            $('#edicaoModal').modal('show');
        },
        atualizar () { 
            this.$util.atualizar(this, { 
                service: 'apoiado_portal_abas',
                dados: this.item,
                reload: true, 
                modal: 'edicaoModal',
            });
        },

        toggle (item) { 

            this.$util.toggle(this, { 
                service: 'apoiado_portal_abas',
                dados: item,
            });

        },
    },

    mounted () { 
        this.breadcrumb = [
            { name: "Configurações", path: "/cadastros"},
            { name: "Portal Apoiado: Abas" },
        ];

        this.$store.commit('setBreadcrumb', this.breadcrumb);

        this.load();

    },

    updated () { 
        $('[data-toggle="tooltip"]').tooltip();
    }


}
</script>